import { jsx as e, jsxs as T, Fragment as b } from "react/jsx-runtime";
import { TEST_IDS as v } from "./testIds.mjs";
import { StyledTabs as y, ScrollButton as S, StyledTab as f, StyledTabLabel as g, StyledTabLoader as h } from "./styles18.mjs";
import { Typography as C } from "./index59.mjs";
import { Badge as L } from "./index27.mjs";
import { memo as $ } from "react";
const x = ({ children: r }) => /* @__PURE__ */ e("div", { children: r }), B = ({
  value: r,
  isLoading: a,
  onChange: s,
  tabs: p = [],
  variant: d = "scrollable",
  orientation: l = "horizontal",
  tabStyle: t = "text",
  testid: i
}) => /* @__PURE__ */ e(
  y,
  {
    $style: t,
    $orientation: l,
    value: r,
    onChange: s,
    textColor: "primary",
    indicatorColor: "primary",
    variant: d,
    orientation: l,
    scrollButtons: "auto",
    allowScrollButtonsMobile: !0,
    ScrollButtonComponent: (o) => /* @__PURE__ */ e(S, { ...o, disableRipple: !0, disableTouchRipple: !0 }),
    children: p.map((o) => {
      const c = `${i || "tabs"}_${o.value}_${v.tab}`.toLowerCase(), n = o.isLoading === void 0 ? a : o.isLoading, m = r === o.value, u = o.Component || x;
      return /* @__PURE__ */ e(
        f,
        {
          $style: t,
          value: o.value,
          label: /* @__PURE__ */ e(u, { children: /* @__PURE__ */ T(g, { children: [
            /* @__PURE__ */ e(C.Overline, { children: o.label }),
            n && /* @__PURE__ */ e(h, { $active: m, size: 16 }),
            !n && /* @__PURE__ */ e(b, { children: typeof o.counter == "number" ? /* @__PURE__ */ e(L, { color: "violet", label: o.counter.toString() }) : o.counter })
          ] }) }),
          "data-testid": c,
          disableRipple: !0,
          disabled: o.isDisabled
        },
        o.value
      );
    })
  }
), W = $(B);
export {
  W as Tabs
};
//# sourceMappingURL=index37.mjs.map
